// load utility classes
import {Generic} from './utils/Generic';
import {Locale} from './utils/Locale';
import {Marketing} from './utils/Marketing';
import {Pricing} from './utils/Pricing';
import {UI} from './utils/UI';
import {URLManager} from './utils/URLManager';
import {Environment} from './utils/Environment';
import {PerformanceHelper} from './utils/PerformanceHelper';

// load other classes
import {StorageUtility} from './utils/Storage';
import {GDPR} from './utils/GDPR';
import * as BreachWatchScanB2BUtil from './utils/BreachWatchScanB2B';
import {Affiliate} from './utils/Affiliate';
import {ProtoBuf} from './utils/ProtoBuf';
import {KeeperWeb} from './utils/servlets/KeeperWeb';
import {BiApi} from './utils/apis/BiApi';

declare var window: any;

// initialize window.keeper object
window.keeper = window.keeper || {};

// apply utility classes to window.keeper
let utilityClasses = {
    Generic,
    Locale,
    Marketing,
    Pricing,
    UI,
    URLManager,
    Environment,
    PerformanceHelper,
};
for (let key in utilityClasses) {
    // get instance
    let instance = utilityClasses[key].getInstance();

    // get instance methods
    let ownProps = Object.getOwnPropertyNames(instance);
    let protoProps = Object.getOwnPropertyNames(Object.getPrototypeOf(instance));

    // get all methods
    let methods = [...new Set([...ownProps, ...protoProps])];
    for (let method of methods) {
        if (
            method !== 'constructor' &&
            method !== 'getInstance' &&
            typeof instance[method] === 'function'
        ) {
            window.keeper[method] = instance[method].bind(instance);
        }
    }
}

// apply other classes to window.keeper
window.keeper.servlets = {
    keeperWeb: new KeeperWeb(),
};
window.keeper.apis = {
    biApi: new BiApi(),
};
window.keeper.storage = StorageUtility.getInstance();
window.keeper.cookieConsent = GDPR.getInstance();
window.Affiliate = Affiliate.getInstance();
window.ProtoBufUtility = ProtoBuf.getInstance();
window.BreachWatchScanB2B = BreachWatchScanB2BUtil.BreachWatchScanB2B.getInstance();
